var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('plan-calendar',{on:{"handleSelectDay":_vm.handleSelectDay,"handleClickItem":_vm.handleClickItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }